module.exports = __webpack_public_path__ + "assets/Vector.fbc5e4ef.svg";